export const APP_UPDATE_HIDE_ALERT = 'APP_UPDATE_HIDE_ALERT';

export function hideAlert() {
  return {type: APP_UPDATE_HIDE_ALERT}
}
